export function registerSettings() {
	const canvasRedraw = () => {
		if (canvas.ready) canvas.tokens.draw();
	};

	// deprecated since 13 until 14
	game.settings.register("hex-size-support", "alwaysShowBorder", {
		scope: "world",
		type: new foundry.data.fields.BooleanField(),
	});

	game.settings.register("hex-size-support", "borderMode", {
		name: "hex-size-support.settings.borderMode.name",
		hint: "hex-size-support.settings.borderMode.hint",
		scope: "world",
		type: new foundry.data.fields.StringField({
			blank: false,
			required: true,
			choices: {
				hover: "hex-size-support.settings.borderMode.choices.hover",
				always: "hex-size-support.settings.borderMode.choices.always",
				combat: "hex-size-support.settings.borderMode.choices.combat",
			},
			initial: game.settings.get("hex-size-support", "alwaysShowBorder") ? "always" : "hover",
		}),
		config: true,
		onChange: canvasRedraw,
	});

	// deprecated since 13 until 14
	game.settings.register("hex-size-support", "borderBehindToken", {
		scope: "world",
		type: new foundry.data.fields.BooleanField(),
	});

	game.settings.register("hex-size-support", "borderPosition", {
		name: "hex-size-support.settings.borderPosition.name",
		hint: "hex-size-support.settings.borderPosition.hint",
		scope: "world",
		type: new foundry.data.fields.StringField({
			blank: false,
			required: true,
			choices: {
				default: "hex-size-support.settings.borderPosition.choices.default",
				front: "hex-size-support.settings.borderPosition.choices.front",
				behind: "hex-size-support.settings.borderPosition.choices.behind",
			},
			initial: game.settings.get("hex-size-support", "borderBehindToken") ? "behind" : "default",
		}),
		config: true,
		onChange: canvasRedraw,
	});

	game.settings.register("hex-size-support", "borderWidth", {
		name: "hex-size-support.settings.borderWidth.name",
		hint: "hex-size-support.settings.borderWidth.hint",
		scope: "world",
		type: Number,
		config: true,
		default: CONFIG.Canvas.objectBorderThickness,
		range: {
			min: 1,
			max: 20,
			step: 1,
		},
		onChange: val => {
			CONFIG.Canvas.objectBorderThickness = val;
			canvasRedraw();
		},
	});
	CONFIG.Canvas.objectBorderThickness = game.settings.get("hex-size-support", "borderWidth");

	game.settings.register("hex-size-support", "fillBorder", {
		name: "hex-size-support.settings.fillBorder.name",
		hint: "hex-size-support.settings.fillBorder.hint",
		scope: "world",
		type: new foundry.data.fields.StringField({
			initial: "none",
			required: true,
			choices: {
				none: "TOKEN.DISPLAY_NONE",
				always: "TOKEN.DISPLAY_ALWAYS",
				combat: "hex-size-support.settings.fillBorder.choices.combat",
				hover: "TOKEN.DISPLAY_HOVER",
				owner: "TOKEN.DISPLAY_OWNER",
				owner_hov: "TOKEN.DISPLAY_OWNER_HOVER",
				control: "TOKEN.DISPLAY_CONTROL",
			},
		}),
		config: true,
		onChange: canvasRedraw,
	});

	game.settings.register("hex-size-support", "borderStyle", {
		name: "hex-size-support.settings.borderStyle.name",
		hint: "hex-size-support.settings.borderStyle.hint",
		scope: "world",
		type: new foundry.data.fields.StringField({
			required: true,
			choices: {
				default: "hex-size-support.settings.borderStyle.choices.default",
				bevel: "hex-size-support.settings.borderStyle.choices.bevel",
				flat: "hex-size-support.settings.borderStyle.choices.flat",
			},
			initial: "default",
		}),
		config: true,
		onChange: canvasRedraw,
	});

	game.settings.register("hex-size-support", "defaultHexShape", {
		name: "hex-size-support.settings.defaultHexShape.name",
		hint: "hex-size-support.settings.defaultHexShape.hint",
		scope: "world",
		type: new foundry.data.fields.NumberField({
			initial: CONST.TOKEN_SHAPES.ELLIPSE_1,
			required: true,
			choices: Object.fromEntries(
				Object.entries(CONST.TOKEN_SHAPES).map(([k, v]) => [v, `TOKEN.SHAPES.${k}.label`])
			),
		}),
		config: true,
	});

	game.settings.register("hex-size-support", "defaultGridlessShape", {
		name: "hex-size-support.settings.defaultGridlessShape.name",
		hint: "hex-size-support.settings.defaultGridlessShape.hint",
		scope: "world",
		type: new foundry.data.fields.NumberField({
			initial: CONST.TOKEN_SHAPES.ELLIPSE_1,
			required: true,
			choices: {
				[CONST.TOKEN_SHAPES.ELLIPSE_1]: "TOKEN.SHAPES.ELLIPSE.label",
				[CONST.TOKEN_SHAPES.RECTANGLE_1]: "TOKEN.SHAPES.RECTANGLE.label",
			},
		}),
		config: true,
	});

	/**
	 * Border Color Settings
	 */

	game.settings.register("hex-size-support", "controlledColor", {
		scope: "client",
		name: "hex-size-support.settings.controlledColor.name",
		type: new foundry.data.fields.ColorField({
			required: true,
			blank: false,
			initial: Color.from(CONFIG.Canvas.dispositionColors.CONTROLLED).toString(),
		}),
		config: true,
		onChange: val => setBorderColor("CONTROLLED", val),
	});
	game.settings.register("hex-size-support", "partyColor", {
		scope: "client",
		name: "hex-size-support.settings.partyColor.name",
		type: new foundry.data.fields.ColorField({
			required: true,
			blank: false,
			initial: Color.from(CONFIG.Canvas.dispositionColors.PARTY).toString(),
		}),
		config: true,
		onChange: val => setBorderColor("PARTY", val),
	});
	game.settings.register("hex-size-support", "friendlyColor", {
		name: "hex-size-support.settings.friendlyColor.name",
		scope: "client",
		type: new foundry.data.fields.ColorField({
			required: true,
			blank: false,
			initial: Color.from(CONFIG.Canvas.dispositionColors.FRIENDLY).toString(),
		}),
		config: true,
		onChange: val => setBorderColor("FRIENDLY", val),
	});
	game.settings.register("hex-size-support", "neutralColor", {
		name: "hex-size-support.settings.neutralColor.name",
		scope: "client",
		type: new foundry.data.fields.ColorField({
			required: true,
			blank: false,
			initial: Color.from(CONFIG.Canvas.dispositionColors.NEUTRAL).toString(),
		}),
		config: true,
		onChange: val => setBorderColor("NEUTRAL", val),
	});
	game.settings.register("hex-size-support", "hostileColor", {
		name: "hex-size-support.settings.hostileColor.name",
		scope: "client",
		type: new foundry.data.fields.ColorField({
			required: true,
			blank: false,
			initial: Color.from(CONFIG.Canvas.dispositionColors.HOSTILE).toString(),
		}),
		config: true,
		onChange: val => setBorderColor("HOSTILE", val),
	});
	game.settings.register("hex-size-support", "secretColor", {
		name: "hex-size-support.settings.secretColor.name",
		scope: "client",
		type: new foundry.data.fields.ColorField({
			required: true,
			blank: false,
			initial: Color.from(CONFIG.Canvas.dispositionColors.SECRET).toString(),
		}),
		config: true,
		onChange: val => setBorderColor("SECRET", val),
	});
	setBorderColor("CONTROLLED", game.settings.get("hex-size-support", "controlledColor"));
	setBorderColor("PARTY", game.settings.get("hex-size-support", "partyColor"));
	setBorderColor("FRIENDLY", game.settings.get("hex-size-support", "friendlyColor"));
	setBorderColor("NEUTRAL", game.settings.get("hex-size-support", "neutralColor"));
	setBorderColor("HOSTILE", game.settings.get("hex-size-support", "hostileColor"));
	setBorderColor("SECRET", game.settings.get("hex-size-support", "secretColor"));

	// Register flipping to keybinds for those that want it.
	game.keybindings.register("hex-size-support", "swapOrientation", {
		name: "hex-size-support.keybinds.swapOrientation.name",
		hint: "hex-size-support.keybinds.swapOrientation.hint",
		onDown: flipControlledTokens,
		editable: [], //[{ key: "KeyR", modifiers: ["Shift"] }],
		precedence: CONST.KEYBINDING_PRECEDENCE.NORMAL,
	});
}

export function finalizeMigration() {
	game.settings.set(
		"hex-size-support",
		"borderMode",
		game.settings.get("hex-size-support", "borderMode")
	);
	game.settings.set("hex-size-support", "alwaysShowBorder", false);

	game.settings.set(
		"hex-size-support",
		"borderPosition",
		game.settings.get("hex-size-support", "borderPosition")
	);
	game.settings.set("hex-size-support", "borderBehindToken", false);
}

/**
 * @param {string} key
 * @param {foundry.utils.Color} value
 */
function setBorderColor(key, value) {
	CONFIG.Canvas.dispositionColors[key] = value.valueOf();
	if (canvas.ready) canvas.draw();
}

/**
 * Toggle the orientation flag on all controlled tokens
 */
function flipControlledTokens() {
	const updates = canvas.tokens?.controlled.map(t => {
		return {
			_id: t.document.id,
			shape: t.document.shape ^ 1,
		};
	});
	canvas.scene?.updateEmbeddedDocuments("Token", updates).then(() => {
		for (const t of canvas.tokens.controlled ?? []) t.draw();
	});
}

/**
My sincerest affection and love for the Pilot NET Discord community. Without your support, patience and good feels I wouldn't have 
ever gotten this far. This is all for you now, I'm sorry I made you all wait for so long.
 - Ember Scaleborne <3

In regards to the 0.8.6 foundry update,
    My deepest thanks for the efforts of @FolkvangrForgent, @Eranziel, @The-E and @Bolts. Without your hard work and nagging, this update would
have been a lot later than it had any right to be be. Life seems to really enjoy kicking me right when a new update comes out >.>
 - Ember Scaleborne 06/26/2021 <3

Big huge thanks to Ember Scaleborne (@Ourobor). I would not have been
able to make this update if you hadn't made this module in the first
place. I hope you are doing well <3
 - Bolts, 09/18/2022
*/
